import { clientEnv } from '@/env/client-env';

export const config = {
  gtmId: clientEnv.gtmMeasurementId,
  gaId: clientEnv.gaMeasurementId,
  cookieName: 'spCookieConsent',
  cookieBannerCookieName: 'cookieConsent',
  // Cookie expiration in days
  cookieExpirationDays: 365,
  cookiePolicyUrl: clientEnv.spCookiePolicyUrl,
} as const;
